import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api";

export default function JybekWidget() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    { role: "jybek", text: "Hi, I'm JyBek. Ask me anything about the system, or tell me where you want to go." },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, [messages, open]);

  const send = async (e) => {
    e.preventDefault();
    const text = input.trim();
    if (!text || loading) return;
    setMessages((m) => [...m, { role: "user", text }]);
    setInput("");
    setLoading(true);
    try {
      const res = await api.jybek.ask(text);
      setMessages((m) => [...m, { role: "jybek", text: res.reply, buttons: res.buttons || [] }]);
    } catch (err) {
      setMessages((m) => [...m, { role: "jybek", text: "Something went wrong reaching JyBek. Try again in a moment." }]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ position: "fixed", bottom: 20, right: 20, zIndex: 1000 }}>
      {open && (
        <div className="bg-white rounded-lg shadow-2xl mb-3 flex flex-col" style={{ width: 340, height: 440 }}>
          <div className="flex items-center justify-between px-4 py-3 rounded-t-lg" style={{ backgroundColor: "#154E93" }}>
            <span className="text-white font-semibold text-sm">JyBek Assistant</span>
            <button onClick={() => setOpen(false)} className="text-white text-lg leading-none">×</button>
          </div>

          <div ref={scrollRef} className="flex-1 overflow-y-auto px-3 py-3 space-y-3">
            {messages.map((m, i) => (
              <div key={i} className={m.role === "user" ? "text-right" : "text-left"}>
                <div className={"inline-block px-3 py-2 rounded-lg text-sm max-w-[85%] " + (m.role === "user" ? "bg-blue-50 text-gray-800" : "bg-gray-100 text-gray-800")}>
                  {m.text}
                </div>
                {m.buttons && m.buttons.length > 0 && (
                  <div className="mt-2 space-x-2">
                    {m.buttons.map((b, bi) => (
                      <button
                        key={bi}
                        onClick={() => { if (b.route) navigate(b.route); }}
                        className="inline-block text-xs px-3 py-1.5 rounded text-white"
                        style={{ backgroundColor: "#154E93" }}
                      >
                        {b.label}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            ))}
            {loading && (
              <div className="text-left">
                <div className="inline-block px-3 py-2 rounded-lg text-sm bg-gray-100 text-gray-400">Thinking…</div>
              </div>
            )}
          </div>

          <form onSubmit={send} className="flex border-t p-2">
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Ask JyBek..."
              className="flex-1 border rounded px-2 py-1.5 text-sm mr-2"
            />
            <button type="submit" disabled={loading} className="px-3 py-1.5 rounded text-white text-sm" style={{ backgroundColor: "#154E93" }}>
              Send
            </button>
          </form>
        </div>
      )}

      <button
        onClick={() => setOpen((v) => !v)}
        className="rounded-full shadow-lg flex items-center justify-center"
        style={{ width: 56, height: 56, backgroundColor: "#154E93" }}
        aria-label="Open JyBek Assistant"
      >
        <span style={{ fontSize: 24 }}>💬</span>
      </button>
    </div>
  );
}
